module.exports = __webpack_public_path__ + "img/qs_gzh.1701f399.png";